let billingCurrencies = {
  adjust_inc: [
    {
      name: 'USD',
      label: 'US Dollar',
    },
  ],
  adjust_kk: [
    {
      name: 'JPY',
      label: 'Yen',
    },
  ],
  adjust_gmbh: [
    {
      name: 'EUR',
      label: 'Euro',
    },
    {
      name: 'USD',
      label: 'US Dollar',
    },
  ],
  adjust_brasil: [
    {
      name: 'BRL',
      label: 'Real',
    },
  ],
  adjust_software_ltd: [
    {
      name: 'GBP',
      label: 'Pound sterling',
    },
  ],
  adjust_korea_ltd: [
    {
      name: 'KRW',
      label: 'South Korean Won',
    },
  ],
};

export { billingCurrencies };
